module.exports = __webpack_public_path__ + "img/t4-14.a7f50d12.svg";